package com.patronat.top.client.presentation.profile

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.patronat.top.client.platform.ClientBackHandler
import com.patronat.top.library.media.data.KmpFileSource
import io.github.vinceglb.filekit.FileKit
import io.github.vinceglb.filekit.dialogs.FileKitMode
import io.github.vinceglb.filekit.dialogs.FileKitType
import io.github.vinceglb.filekit.dialogs.openFilePicker
import io.github.vinceglb.filekit.mimeType
import io.github.vinceglb.filekit.name
import io.github.vinceglb.filekit.readBytes
import org.koin.compose.koinInject

@Composable
fun ClientProfileRoute(
    onAuthRequested: () -> Unit,
    onVenueDetailsRequested: (String) -> Unit,
    onFullScreenChanged: (Boolean) -> Unit
) {
    val viewModel: ClientProfileViewModel = koinInject()
    val state by viewModel.viewState.collectAsState()

    LaunchedEffect(viewModel) {
        viewModel.onEvent(ClientProfileEvent.OnRefresh)
    }

    LaunchedEffect(state.screen) {
        onFullScreenChanged(state.screen != ClientProfileScreen.Main)
    }

    DisposableEffect(Unit) {
        onDispose {
            onFullScreenChanged(false)
        }
    }

    LaunchedEffect(viewModel) {
        viewModel.effect.collect { effect ->
            when (effect) {
                ClientProfileEffect.OpenAuth -> onAuthRequested()
                is ClientProfileEffect.OpenVenueDetails -> onVenueDetailsRequested(effect.venueId)
                ClientProfileEffect.OpenAvatarPicker -> pickAvatar(viewModel)
            }
        }
    }

    ClientBackHandler(
        enabled = state.screen != ClientProfileScreen.Main,
        onBack = { viewModel.onEvent(ClientProfileEvent.OnBackClicked) }
    )

    ClientProfileContent(
        state = state,
        onEvent = viewModel::onEvent
    )
}

private suspend fun pickAvatar(viewModel: ClientProfileViewModel) {
    val file = FileKit.openFilePicker(
        type = FileKitType.Image,
        mode = FileKitMode.Single
    ) ?: return

    val fileName = file.name.ifBlank { "avatar.jpg" }
    val bytes = runCatching { file.readBytes() }.getOrNull() ?: return
    val mimeType = file.mimeType()?.toString()
        ?.takeIf { it.startsWith("image/") }
        ?: fileName.defaultImageMimeType()

    viewModel.onEvent(
        ClientProfileEvent.OnEditAvatarPicked(
            ClientProfilePickedFile(
                fileSource = KmpFileSource(
                    name = fileName,
                    bytes = bytes,
                    platformSource = file
                ),
                mimeType = mimeType,
                fileName = fileName
            )
        )
    )
}

private fun String.defaultImageMimeType(): String {
    return when (substringAfterLast('.', missingDelimiterValue = "").lowercase()) {
        "png" -> "image/png"
        "webp" -> "image/webp"
        "heic" -> "image/heic"
        "heif" -> "image/heif"
        else -> "image/jpeg"
    }
}
